import { render, staticRenderFns } from "./temp-chart-visualizer.vue?vue&type=template&id=20ec3749&scoped=true&"
import script from "./temp-chart-visualizer.vue?vue&type=script&lang=js&"
export * from "./temp-chart-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./temp-chart-visualizer.vue?vue&type=style&index=0&id=20ec3749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec3749",
  null
  
)

export default component.exports